import { useTranslation } from "react-i18next";

import { useSelector } from "react-redux";
import { useState } from "react";

import { usePageTitle } from "@/utils/usePageTitle";

import EditableCompanyBalanceList from "./components/EditableCompanyBalanceList";
import { useGetCompanyBalancesQuery } from "../../redux/company-balance/company-balance.api";
import { companyBalanceSelector } from "../../redux/company-balance/company-balance.slice";

export default function ManageCompanyBalance() {
	const { isLoading: isLoadingInitialData } = useGetCompanyBalancesQuery();
	const { t } = useTranslation();
	const ts = (key: string) => t(`manage-company-balance.${key}`);
	const companyBalances = useSelector(companyBalanceSelector);
	const [editingCompanyBalanceId, setCompanyBalanceId] = useState(-1);

	usePageTitle(ts("title"));

	return (
		<div className="p-6">
			<EditableCompanyBalanceList
				data={companyBalances}
				editingCompanyBalanceId={editingCompanyBalanceId}
				isLoading={isLoadingInitialData}
				setEditingCompanyBalanceId={setCompanyBalanceId}
			/>
		</div>
	);
}
